export default "__VITE_ASSET__b4712b7b__"